import { ROUTES } from "@/shared/routing/routes"

const ELIGIBLE_ROUTES = [
  ROUTES.prepackages.path,
  ROUTES.healthCoverage.path,
  ROUTES.healthCoverageParam.path,
  ROUTES.tribeQuote.path,
  ROUTES.userInformations.path,
  ROUTES.userAddress.path,
  ROUTES.userBirthInformations.path,
  ROUTES.pricing.path,
  ROUTES.recap.path,
]

export function isSendMyQuoteEligible(pathname: string): boolean {
  return ELIGIBLE_ROUTES.some((route) => pathname.includes(route))
}
